import {Component, OnInit, Input, EventEmitter, Output, Directive, SimpleChanges, ViewChild} from '@angular/core';
import { QueryOptions } from 'src/app/model/query-options';
import {LazyLoadEvent, MenuItem, MessageService, SortEvent} from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxPermissionsService, NgxRolesService, NgxPermissionsModule} from 'ngx-permissions';
import { JobService } from '@app/services/job.service';
import { RecruiterService } from '@app/services/recruiterService';
import { StatusService } from '@app/services/status.service';
import { TechnologyService } from '@app/services/technology.service';
import { JobCategoryService } from '@app/services/jobCategory.service';
import { CvSubmitService } from '@app/services/cvsubmit.service';
import { Messages } from '@app/constants/constant';
import { DatePipe } from '@angular/common';
import {NgForm} from "@angular/forms";
import {AuthenticationService} from "@app/services/authentication.service";
import {CvSubmit} from "@app/model/cvSubmit";
import { RecruiterServiceGet } from '@app/services/recruiterService.get';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css'],
  providers:[NgxPermissionsService,NgxRolesService,NgxPermissionsModule]
})
export class TableComponent implements OnInit {

  @Input() records: [];
  fileUrlDomain=Messages.endpoint.fileUrlDomain;
  totalRecords: number;
  display: boolean;
  rowDataId:any;
  totalPages: Number;
  @Input() columns: any[];
  @Input() title: any[];
  @Input() refreshTable :any;
  @Input() pageSize: number = 25;

  @Input() apiService: any;
  @Output() openModal = new EventEmitter<any>();
  @Input() onChangeFieldsValues : boolean;

  selectedColumns: any[];
  jobFieldMapper = new Map<string, string>();
  filter :any={
    categoryFilter:'',
    technologyFilter:'',
    recruiterFilter:'',
    statusFilter:''
  }
  loading: boolean = false;
  exportColumns: any[];
  actionItems: MenuItem[];
  first: number = 0;
  pageSizeVar: number;
  activatedUrl:any;
  statusList: any;
  technologyList: any;
  recruiterList: any;
  categoryList: any;
  modalTitle: any;
  cvSubmitId: any;
  cvSubmitted: string;
  cvShortListed: string;
  jdId: any;
  jdName: string;
  recruiterId: string;
  recruiterName: string;
  submitDate: any;
  jobPositionData: any;
  yearFilter: any;
  minDate:any= new Date();
  offerDate:any= new Date();
  rId:any;
  yearTimeout: any;
   sortField: any = 'createdOn' ;
   sortOrder: any = '-1';
  constructor(private _router: Router, private activatedRoute: ActivatedRoute,
              private _apiStatus: StatusService,
              private _apiTechnology: TechnologyService,
              private _apiJobCategories: JobCategoryService,
              private _cvSubmit: CvSubmitService,
              private  _authenticationService: AuthenticationService,
              private _apiRecruiter: RecruiterService,
              private _apiRecruiterGet:RecruiterServiceGet,
              private _toastService : MessageService,
              private spinner: NgxSpinnerService,
              private _DatePipe: DatePipe) {
   }
  @ViewChild('cvSubmitForm',{static: false}) public cvSubmitForm: NgForm;
   ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (propName == 'refreshTable') {
        const change = changes[propName];
        const curVal = JSON.stringify(change.currentValue);
        const prevVal = JSON.stringify(change.previousValue);
        if (curVal == 'true') {
          this.onLoad();
        }
      }
    }
  }

  ngOnInit() {
    this.activatedUrl = this.activatedRoute.snapshot.url[0].path;
    this.selectedColumns = this.columns;
    this.actionItems = [
      { label: 'Download PDF', icon: 'pi pi-file-pdf', command: (event) => { this.exportPdf(); } },
      { label: 'Download XLS', icon: 'pi pi-file-excel', command: (event) => { this.exportExcel(); } },
      { label: 'Create Position', icon: 'pi pi-plus', command: (event) => { this.gotoCreatePosition(); }}];
    this.jobFieldMapper.set('jobPriority', 'priority');
    this.jobFieldMapper.set('technology', 'technology');
    this.pageSizeVar = this.pageSize;
    const params = this.queryParamsDropDownFilter();
    this._apiStatus.list(params).subscribe(res => {
      this.statusList = res;
    });
    this._apiTechnology.list(params).subscribe(res => {
      this.technologyList = res;
    });
    this._apiRecruiterGet.list(params).subscribe(res => {
      this.recruiterList = res;
    });
    this._apiJobCategories.list(params).subscribe(res => {
      this.categoryList = res;
    });
  }
  gotoCreatePosition(){
    this._router.navigate(['manage-position']);
  }
  onYearChange(event, dt) {
    if (this.yearTimeout) {
        clearTimeout(this.yearTimeout);
    }

    this.yearTimeout = setTimeout(() => {
        dt.filter(event.value, 'year', 'gt');
    }, 250);
}
  onLoad(event?: LazyLoadEvent) {
    this.spinner.show();
    this.loading = true;
    //event.first = First row offset
    //event.rows = Number of rows per page
    //event.sortField = Field name to sort with
    //event.sortOrder = Sort order as number, 1 for asc and -1 for dec
    //filters: FilterMetadata object having field as key and filter value, filter matchMode as value
    if(event){
     this.sortField = event.sortField == undefined ? 'createdOn' : event.sortField;
     this.sortOrder = event.sortOrder ? event.sortOrder : -1;
     this.first = event.first ? event.first: 0;
    }
    let queryParams = new Object();
    let dateRange=new Array();
    if(this.yearFilter && this.yearFilter.length>1){
      dateRange.push( this._DatePipe.transform(this.yearFilter[1],'dd/MM/yyyy'))
      dateRange.push(this._DatePipe.transform(this.yearFilter[0],'dd/MM/yyyy'))
    }
    let category= this.filter.categoryFilter ?  this.filter.categoryFilter :null;
    let technology=this.filter.technologyFilter? this.filter.technologyFilter :null;
    let recruiter=this.filter.recruiterFilter? this.filter.recruiterFilter :null;
    let status=this.filter.statusFilter ? this.filter.statusFilter :null;

    //sort order as number, 1 for asc and -1 for dec
    queryParams['sortParam'] = {'sortField': this.jobFieldMapper.get(this.sortField) !== undefined ? this.jobFieldMapper.get(this.sortField) : this.sortField, 'sortOrder': this.sortOrder};
    queryParams['pageParam'] = {'page': this.first/this.pageSizeVar, 'size': this.pageSizeVar};
    queryParams['filterParam'] = {'status':status,'category':category,'technology':technology, 'recruiter':recruiter, 'dateRange':dateRange && dateRange.length > 1 ? dateRange[0] +'-'+dateRange[1] : null };
    let tableSortingQueryOption= new QueryOptions(queryParams);
    //pass values in query map eg -> sortParam and pageParam
    tableSortingQueryOption.toQueryMap();// for passing request params. this is the job id
    this.apiService.newList1(tableSortingQueryOption).subscribe(res => {
      this.spinner.hide();
      this.records = res.content;
      this.pageSize = res.pageSize;
      this.totalRecords = res.totalRecords;
      this.totalPages = res.totalPages;
      });
    this.loading = false;
    this.exportColumns = this.columns.map(col => ({ title: col.header, dataKey: col.field }));
  }
queryParamsDropDownFilter(){
  let queryParams = new Object();
    //sort order as number, 1 for asc and -1 for dec
    queryParams["sortParam"] = { sortField: "name", sortOrder: 1 };
    queryParams["pageParam"] = {
      page:
        this.first / this.pageSize > 1
          ? this.first / this.pageSize + 1
          : this.first / this.pageSize,
      size: this.pageSize
    };
    const dropDownSortingQueryOptions = new QueryOptions(queryParams);
      dropDownSortingQueryOptions.toQueryMap();
      return dropDownSortingQueryOptions;
}
  exportPdf() {
    import("jspdf").then(jsPDF => {
      import("jspdf-autotable").then(x => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, this.records);
        doc.save('rms_' + new Date() + '.pdf');
      })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.records);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "rms");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }
  showModel = function(showModalFlag: boolean, rowData: any, componentToOpen: String) {
    const x = {
      showModalFlag,
     fields: rowData,
     action : componentToOpen
    };
    this.openModal.emit(x);
  };

  async editCVSubmit(rowData, reportType, reportName) {
    var cvSubmitData: CvSubmit;
    this.rId = '';
    if (rowData.jobAssignedRecruiter && rowData.jobAssignedRecruiter.users.length > 0 && rowData.jobAssignedRecruiter.users.length === 1) {
      this.rId = rowData.jobAssignedRecruiter.users[0].id;
    } else {
      var currentUser = this._authenticationService.currentUserValue ? this._authenticationService.currentUserValue['user'] : '';
      this.rId = currentUser.id;
    }
    this.jdId = rowData.jobDescription.id;
    const promise = await this._cvSubmit.getCVSubmit( rowData.jobDescription.id, Messages.endpoint.cvSubmit_search, this.rId).toPromise().then((data) => {
      this.display = true;
      this.modalTitle = reportName;
      if (data) {
        this.cvSubmitId = data.id;
        this.cvSubmitted = data.cvSubmitted;
        this.cvShortListed = data.cvShortListed;
        this.jdId = data.jdId;
        this.jdName = data.jdName;
        this.recruiterId = data.recruiterId;
        this.recruiterName = data.recruiterName;
        this.submitDate = data.submitDate;
        this.offerDate = new Date();
      }
    }).catch((error) => {
      console.log('Promise rejected with ' + JSON.stringify(error));
    });

  }

  async loadCVSubmit(event) {
    const promise = await this._cvSubmit.getCVSubmit( this.jdId, Messages.endpoint.cvSubmit_search, this.rId, String(this._DatePipe.transform(this.offerDate ,'dd/MM/yyyy'))).toPromise().then((data) => {
      this.display = true;
      if (data) {
        this.cvSubmitId = data.id;
        this.cvSubmitted = data.cvSubmitted;
        this.cvShortListed = data.cvShortListed;
        this.jdId = data.jdId;
        this.jdName = data.jdName;
        this.recruiterId = data.recruiterId;
        this.recruiterName = data.recruiterName;
        this.submitDate = data.submitDate;
      }
    }).catch((error) => {
      console.log('Promise rejected with ' + JSON.stringify(error));
    });

  }

  updateCVSubmit(cvSubmitForm: NgForm) {
    let cvSubmit = new CvSubmit();
    cvSubmit.cvSubmitted = cvSubmitForm.value.cvSubmitted1;
    cvSubmit.cvShortListed = cvSubmitForm.value.cvShortListed1;
    cvSubmit.jdId  = cvSubmitForm.value.jdId;
    cvSubmit.jdName = cvSubmitForm.value.jdName;
    cvSubmit.recruiterId = cvSubmitForm.value.recruiterId;
    cvSubmit.recruiterName = cvSubmitForm.value.recruiterName;
    cvSubmit.submitDate = cvSubmitForm.value.submitDate;
    cvSubmit.submitDate = String(this._DatePipe.transform(cvSubmit.submitDate ,'dd MMM yyyy hh:mm a'));

    cvSubmit.id = cvSubmitForm.value.cvSubmitId;

    this._cvSubmit.update(cvSubmit, 'cvsubmit').subscribe(
        res => {
            this.showCVSubmitToast();
            this.cvSubmitted = '0';
            this.cvShortListed = '0';
            this.jdId = '';
            this.jdName = '';
            this.recruiterId = '';
            this.recruiterName = '';
            this.submitDate = String(this._DatePipe.transform(new Date() ,'d M yy'));
            this.cvSubmitId = '';
            this.display = false;
            this.cvSubmitForm.reset();
        }, (err) => { this.showCVSubmitToast();
        });
  }
  clearAllFilter(event) {
    this.filter.technologyFilter = '';
    this.filter.recruiterFilter = '';
    this.filter.statusFilter = '';
    this.filter.categoryFilter = '';
    this.yearFilter = '';
    this.onLoad(event);
  }
  showCVSubmitToast = function() {
    this._toastService.add({ severity: 'success', summary: 'Cv submit updated successfully', detail: '' });
  }
  editJob = function(rowData: any, editFlag) {
    this._router.navigate(['manage-position', {id: rowData.id, edit: editFlag}]);
  };
}
